import { AppState } from "../root.reducer";

export const isCreditHistoryLoadingSelector = (state: AppState) => state.creditHistory.isLoading;
export const creditHistorySelector = (state: AppState) => state.creditHistory.creditHistory;